import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const useGoogleAnalytics = (trackingId) => {
    const location = useLocation();
    const initialized = useRef(false);

    // Load Google Analytics script ONCE
    useEffect(() => {
        if (!initialized.current && trackingId) {
            initialized.current = true;

            const script = document.createElement("script");
            script.async = true;
            script.src = `https://www.googletagmanager.com/gtag/js?id=${trackingId}`;
            document.head.appendChild(script);

            window.dataLayer = window.dataLayer || [];
            function gtag(){ window.dataLayer.push(arguments); }
            window.gtag = gtag;

            gtag("js", new Date());
            gtag("config", trackingId, { page_path: window.location.pathname });
        }
    }, [trackingId]);  // <-- satisfies ESLint safely

    // Track route changes
    useEffect(() => {
        const pageTitles = {
            "/": "Table",
            "/charts": "Charts",
            "/about": "About",
        };

        const newTitle = pageTitles[location.pathname] || "React App";
        document.title = newTitle;

        if (window.gtag && trackingId) {
            window.gtag("config", trackingId, {
                page_path: location.pathname,
                page_title: newTitle,
            });
        }
    }, [location, trackingId]);
};

export default useGoogleAnalytics;
